import { george, pr, theme } from "aaa";
import { ui } from "components/util/uiHelpers";
import { observer } from "mobx-react";
import * as moment from "moment";
import * as React from "react";
import { FormattedHTMLMessage } from "react-intl";
import { pushRoute } from "stores/RouterFunctions";
import { amountToCurrencyString, amountToNumber } from "types/amount";
import { IGidDevice } from "types/ebvSecapp";
import { SectionHeader } from "../components/SectionHeader";
import { Settings } from "../components/Settings";
import { SettingsButton } from "../components/SettingsButton";
import { SettingsButtonIcon } from "../components/SettingsButtonIcon";
import { SettingsButtonsContainer } from "../components/SettingsButtonsContainer";
import { SigningMethodBanner } from "../components/SigningMethodBanner";
import { GidSettingsDeleteConfirmationDialog } from "./GidSettingsDeleteConfirmationDialog";
import { GidSettingsRoutes } from "./GidSettingsRoutes";
import { GidSettingsStore } from "./GidSettingsStore";

const MyDevices = observer(({ store, style }: { store: GidSettingsStore, style?: React.CSSProperties }) => {
    const [showConfirmDeleteDialog, setShowConfirmDeleteDialog] = React.useState(false);

    const handleDeleteDevice = (device: IGidDevice) => {
        ui.isPopupVisible = true;
        store.deviceToDelete = device;
        setShowConfirmDeleteDialog(true);
    };

    const handleConfirmDeleteDevice = async (deleteDevice?: boolean) => {
        setShowConfirmDeleteDialog(false);
        ui.isPopupVisible = false;
        if (deleteDevice && store.deviceToDelete) {
            try {
                await store.deleteGidSettingsDevice();
                // pushRoute(GidSettingsRoutes.DELETE_DEVICE_SIGNING);
                pushRoute(GidSettingsRoutes.DELETE_DEVICE_SUCCESS);
            } catch (err) {
                pushRoute("/error");
            }
        }
    };

    // debug.log("devices in store", store.devices!);
    const devices = store.devices && store.devices.map((device, index) => {
        const icon = require("assets/phone.svg");

        return (
            <SettingsButton
                key={device.id}
                border={index > 0 ? "top" : "none"}
                borderRadius={index === store.devices.length - 1 ? "bottom" : "none"}
                icon={<SettingsButtonIcon src={icon} />}
            >
                <div style={{ flex: 1 }}>
                    <pr.P_14_CONTENT style={{ color: theme.customColors.georgeLightGrey }}>
                        {`${ui.__("sidentitySettings.activationDate")} ${moment(device.creationDate.substr(0, device.creationDate.length - 10)).format("DD.MM.YYYY")}`}
                    </pr.P_14_CONTENT>
                    <pr.P_14_CONTENT style={{ color: theme.customColors.georgeLightGrey }}>
                        {`${ui.__("sidentitySettings.lastLoginDate")} ${moment(device.lastLoginDate.substr(0, device.creationDate.length - 10)).format("DD.MM.YYYY")}`}
                    </pr.P_14_CONTENT>

                    <pr.P_16_TITLE style={{ color: ui.isDarkMode ? "white" : "#0A285C", fontWeight: 500, marginTop: 4 }}>{device.friendlyName}</pr.P_16_TITLE>
                </div>
                {store.devices && store.devices.length > 1 &&
                    <SettingsButtonIcon
                        src={require("assets/bin.svg")}
                        onClick={() => handleDeleteDevice(device)}
                        aria-label={ui.__("sidentitySettings.deleteDevice.confirm.title")}
                    />
                }
            </SettingsButton>
        );
    });

    if (store.devices.length === 0) {
        return null;
    }

    return (
        <SettingsButtonsContainer style={style}>
            <SettingsButton border="bottom" borderRadius="top" variant="dense">
                <pr.P_18_TITLE style={{ fontWeight: 700 }}>
                    {ui.__("gidSettings.activatedDevices")}
                </pr.P_18_TITLE>
            </SettingsButton>
            {devices}
            <GidSettingsDeleteConfirmationDialog
                show={showConfirmDeleteDialog}
                onClose={handleConfirmDeleteDevice}
            />
        </SettingsButtonsContainer>
    );
});

export const GidSettingsHomeScreen = observer(({ store }: { store: GidSettingsStore }) => {

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    if (store.isLoading) {
        return (
            <george.LoadingIndicator isLoading height={ui.windowHeight} />
        );
    }

    let limit = ui.__("gid.limit.none");
    if (store.currentLimit && amountToNumber(store.currentLimit) > 0) {
        limit = amountToCurrencyString(store.currentLimit);
    }

    return (
        <george.Background style={{ padding: 16 }}>
            <SectionHeader>{ui.__("gidSettings.signingMethod")}</SectionHeader>
            <SigningMethodBanner>
                <FormattedHTMLMessage id="gidSettings.signingMethod.georgeToken" />
            </SigningMethodBanner>
            <Settings store={store.aliasStore} limit={limit} limitManagementRoute={GidSettingsRoutes.LIMIT} showLimit style={{ marginTop: 16 }} />
            <MyDevices store={store} style={{ marginTop: 16 }} />
        </george.Background>
    );
});



// WEBPACK FOOTER //
// ./src/components/loginManagement/gidSettings/GidSettingsHomeScreen.tsx